import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

// ⭐ Async thunk for manager → operation person reassign
export const operationActionReassign = createAsyncThunk(
    "project/operationActionReassign",
    async ({ projectid, userid }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `${BackendURL}/managerProjectRequested/operation/reassign`,
                { projectid, userid }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { error: "Something went wrong" }
            );
        }
    }
);

const operationReassignSlice = createSlice({
    name: "operationReassign",
    initialState: {
        loading: false,
        success: false,
        error: null,
        message: null,
    },

    reducers: {
        resetOperationReassignState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
            state.message = null;
        },
    },

    extraReducers: (builder) => {
        // Pending
        builder.addCase(operationActionReassign.pending, (state) => {
            state.loading = true;
            state.success = false;
            state.error = null;
        });

        // Fulfilled
        builder.addCase(operationActionReassign.fulfilled, (state, action) => {
            state.loading = false;
            state.success = true;
            state.message = action.payload?.message;
        });

        // Rejected
        builder.addCase(operationActionReassign.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.error || "Something went wrong";
        });
    },
});

export const { resetOperationReassignState } = operationReassignSlice.actions;

export default operationReassignSlice.reducer;
